import { HOUR, MONTH } from '@proton/shared/lib/constants';

export const DISMISSED_ACCESS_CHECK_MAX_AGE = 6 * MONTH;

export const SECURITY_SESSION_MAX_AGE = 1 * HOUR;
